import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";

// B12 (B2a Integration Health): per-integration error history, newest first.
export default function IntegrationErrorHistory() {
  const [h, setH] = useState(null);
  const [err, setErr] = useState("");
  const [off, setOff] = useState(false);
  useEffect(() => { api.get("/comms/admin/integration-errors").then((r) => setH(r.data)).catch((e) => {
    if (e?.response?.data?.detail?.code === "module_disabled") setOff(true);       // Communications module inactive
    else setErr(e?.response?.data?.detail?.message || "Could not load error history.");
  }); }, []);
  if (off) return null;
  return (
    <section className="border border-erf-borderCream bg-white rounded-md px-4 py-3 mb-4 mx-auto w-full max-w-[1600px] box-border md:px-6" data-testid="integration-error-history">
      <h2 className="font-display font-semibold text-erf-dark">Error history</h2>
      {err && <p role="alert" className="text-sm text-red-800" data-testid="integration-error-history-error">{err}</p>}
      {h && Object.entries(h).map(([k, rows]) => (
        <details key={k} className="py-2 border-b border-erf-borderCream last:border-0" data-testid={`ieh-${k}`}>
          <summary className="cursor-pointer min-h-[44px] flex items-center font-semibold">{k.replace(/_/g, " ")} · {rows.length} error(s)</summary>
          {rows.length === 0 ? <p className="text-sm">No recorded errors.</p> : (
            <ul className="text-sm space-y-1">{rows.map((r, i) => <li key={i} data-testid={`ieh-${k}-${i}`}><span className="font-mono text-xs">{(r.at || "").slice(0, 16).replace("T", " ")}</span> · {r.source} · {r.detail}</li>)}</ul>)}
        </details>))}
    </section>
  );
}
